import { RestService } from './restService';
import { Meeting } from '../models';

export class MeetingService extends RestService<Meeting> {
    public constructor(baseUrl: string, baseRoute: string) {
        super(baseUrl, baseRoute);
    }
}
